import React, { useState } from 'react';
import { Input, Tooltip } from 'antd';
import { EyeOutlined, EyeInvisibleOutlined, LockOutlined, InfoCircleOutlined } from '@ant-design/icons';

interface SensitiveInputProps {
  id?: string;
  value: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  disabled?: boolean;
}

interface SecretRefInputProps {
  envVarName: string;
}

export const SensitiveInput: React.FC<SensitiveInputProps> = ({ id, value, onChange, placeholder, disabled = false }) => {
  const [visible, setVisible] = useState(false);

  const displayValue = visible ? value : value ? '••••••••' : '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (visible && onChange) onChange(e);
  };

  return (
    <Input
      id={id}
      type="text"
      autoComplete="off"
      spellCheck={false}
      placeholder={placeholder}
      value={displayValue}
      readOnly={!visible || disabled}
      onChange={handleChange}
      suffix={
        visible ? (
          <EyeInvisibleOutlined
            onClick={() => !disabled && setVisible(false)}
            style={{ cursor: disabled ? 'default' : 'pointer', color: '#888' }}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          />
        ) : (
          <EyeOutlined
            onClick={() => !disabled && setVisible(true)}
            style={{ cursor: disabled ? 'default' : 'pointer', color: '#888' }}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          />
        )
      }
    />
  );
};

export const SecretRefInput: React.FC<SecretRefInputProps> = ({ envVarName }) => (
  <Input
    type="text"
    readOnly
    value={envVarName}
    prefix={<LockOutlined style={{ color: '#faad14' }} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />}
    suffix={
      <Tooltip title="El valor se gestiona via variable de entorno en el servidor. Para modificarlo, actualiza la variable de entorno o el vault correspondiente.">
        <InfoCircleOutlined style={{ color: '#888', cursor: 'help' }} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined} />
      </Tooltip>
    }
    style={{ backgroundColor: '#fffbe6', borderColor: '#ffe58f', color: '#666' }}
  />
);

export default SensitiveInput;
